import {GetRequest} from "@configs/request";
import {urls} from "@api/urls";

export const getUI = () => {
    let token = localStorage.getItem('token');
    return dispatch => {
        let UI = localStorage.getItem("UI");
        if (UI)
            try {
                dispatch({
                    type: 'UI',
                    data: JSON.parse(UI)
                })
            } catch (e) {
            }
        GetRequest(urls.web.ui, null, {'Authorization': token})
            .then((response) => {
                if (response) {
                    let result = response;
                    if (result.ok && result.data) {
                        result = result.data;
                        dispatch({
                            type: 'UI',
                            data: result
                        })
                        try {
                            delete result.home;
                            localStorage.setItem("UI", JSON.stringify(result))
                        } catch (e) {
                        }
                    }
                }
            })
    }
}
